import "./staightPage.css";
import { Link } from "react-router-dom";
import { ImageComponent } from '../../global/imageComponent';
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { isInternalAppLink } from "../../../utility/cmsContent";
import { PHONE_SHELL_MAX_PX } from "../../../utility/phoneShell";

function useAutoSlide() {
    const query = `(max-width: ${PHONE_SHELL_MAX_PX}px)`;
    const [on, setOn] = useState(() =>
        typeof window !== "undefined" && window.matchMedia(query).matches
    );
    useEffect(() => {
        const media = window.matchMedia(query);
        const sync = () => setOn(media.matches);
        sync();
        media.addEventListener("change", sync);
        return () => media.removeEventListener("change", sync);
    }, [query]);
    return on;
}

export default function SportsEventsSlider({ data }) {
    const autoSlide = useAutoSlide();
    const modules = [Navigation];
    if (autoSlide && Autoplay) modules.push(Autoplay);
    return (
        <div className='sportsEventsSliderWrapper'>
            <button className='sliderEventCustomBtn sliderEventLeftBtn'>
                <span>
                    <IoIosArrowBack />
                </span>
            </button>
            <Swiper
                modules={modules}
                autoplay={autoSlide && Autoplay ? { delay: 4500, disableOnInteraction: false } : false}
                loop={Boolean(autoSlide && data?.length > 1)}
                spaceBetween={10}
                slidesPerView={3}
                className='eventSwiper'
                breakpoints={
                    {
                        0: {
                            slidesPerView: 1,
                        },
                        425: {
                            slidesPerView: 2,
                        },
                        600: {
                            slidesPerView: 3,
                        }
                    }
                }
                navigation={{
                    prevEl: '.sliderEventLeftBtn',
                    nextEl: '.sliderEventRightBtn'
                }}
            >
                {data?.map((item, index) => {
                    const slideContent = (
                        <div className='eventSliderContent'>
                            <ImageComponent
                                staticImgSrc={item.imgSrc}
                                dynamicURL={item.imageUrl}
                                alt={item.title || "banner"}
                            />
                        </div>
                    );

                    return (
                        <SwiperSlide className='eventSwiperSlide' key={item._id || index}>
                            {isInternalAppLink(item.linkUrl) ? (
                                <Link to={item.linkUrl} className="eventSliderLink">
                                    {slideContent}
                                </Link>
                            ) : item.linkUrl ? (
                                <a
                                    href={item.linkUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="eventSliderLink"
                                >
                                    {slideContent}
                                </a>
                            ) : (
                                slideContent
                            )}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <button className='sliderEventCustomBtn sliderEventRightBtn'>
                <span>
                    <IoIosArrowForward />
                </span>
            </button>
        </div>
    );
}
